import { connect } from "react-redux";
import { password } from "../actions";
import PasswordComponent from "../components/password.jsx";

const mapStateToProps = (state) => ({
  errors: state.auth.password.errors,
});

export default connect(
  mapStateToProps,
  {
    password: password.request,
  },
)(PasswordComponent);
